import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NotLoggedInGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.requestUser().pipe(
      map(user => {
        if (!user) {
          return true; // Utente non loggato → consenti accesso
        } else {
          this.router.navigate(['/dashboard']); // Utente già loggato → reindirizza
          return false;
        }
      }),
      catchError(() => of(true)) // Errore nella richiesta utente → consenti comunque accesso (non loggato)
    );
  }
}
